import {MdOutlineDoNotDisturbAlt} from "react-icons/md";

export default function PageNotFound({className, ...props}) {

    return (
        <div className={`flex items-center text-[4rem] xl:text-[7rem] font-extrabold  flex-col text-secondary-900  gap-10 w-full h-full ${className}`}>
            <h1 className={"mt-32    "}>
                404
            </h1>

            <h1 className={"text-[1rem] xl:text-[3rem]  -mt-[50px] "}>
                Page Not Found
            </h1>

        </div>

    )
}